import TurmasIndexPage from "@/Pages/Turmas/index.vue";
import NewEditTurmaPage from "@/Pages/Turmas/NewEditTurmaPage.vue";
import TurmasViewPage from "@/Pages/Turmas/view.vue";
import TurmasDashboard from "@/Pages/Turmas/dashboard.vue";
import TurmasBolsaFamilia from "@/Pages/Turmas/TurmasBolsaFamilia.vue";
import { can } from "@/plugins/can";

const checkPermission = (permissions) => {
  return (to, from, next) => {
    if (!can(permissions)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
};

export default [
  {
    path: "/turmas/",
    name: "turmas",
    component: TurmasIndexPage,
    beforeEnter: checkPermission(["turmas.criarTurma", "turmas.*"]),
  },
  {
    path: "/turmas/create",
    name: "turmas.create",
    component: NewEditTurmaPage,
    props: { editing: false },
  },
  {
    path: "/turmas/edit/:turma_id",
    name: "turmas.edit",
    component: NewEditTurmaPage,
    props: { editing: true },
  },
  {
    path: "/turmas/view/:turma_id",
    name: "turmas.view",
    component: TurmasViewPage,
  },
  {
    path: "/turmas/:id/metricas",
    name: "turmas.dashboard",
    component: TurmasDashboard,
  },
  {
    path: "/turmas/:id/bolsa-familia",
    name: "turmas.bolsa_familia",
    component: TurmasBolsaFamilia,
    beforeEnter: checkPermission(["bolsaFamilia.index"]),
  },
];
